import './App.css';
import Header from "./components/Header";
import Home from "./screen/Home"
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import About from "./screen/About";
import Contact from "./screen/Contact";
import DetailsPage from "./screen/DetailsPage";
import Footer from "./components/Footer";
import MentionsLegales from "./screen/MentionsLegales";
import PolitiqueConfidentialite from "./screen/PolitiqueConfidentialite";
import PolitiqueCookies from "./screen/PolitiqueCookies";
import CookieConsent from "./components/CookieConsent";


function App() {

    const handleConsentChange = (consent) => {
        console.log("Consentement cookies:", consent);

        // Ici tu peux aussi activer/désactiver d'autres scripts custom
        // ex: Hotjar, Pixel Meta, etc.
    };
  return (
    <div className="App">

        <Router>

            <Header />
            <div>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="/details/:id" element={<DetailsPage />} />
                    <Route path="/mentions-legales" element={<MentionsLegales/>} />
                    <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite/>} />
                    <Route path="/politique-cookies" element={<PolitiqueCookies/>} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </div>

            <CookieConsent
                onConsentChange={handleConsentChange}
                ga4MeasurementId="G-XXXXXXXXXX"   // remplace par ton ID GA4
                useMatomo={false}                 // mets true si tu utilises Matomo
            />
            <Footer/>
        </Router>
    </div>
  );
}

export default App;
